export default __webpack_public_path__ + "static/media/hogwarts.deb3cea8.png";